import React, { useState, useEffect } from 'react';
import env from '../../config';
import { useNavigate } from 'react-router-dom';
// import './Login.scss';
import '../../tailwind.css';

// Configuração simples de usuários para o login por imagem
const IMAGE_USERS = [
  { id: 'miguel', name: 'Miguel', img: '/assets/img/users/miguel.png', password: '123', totalDescontado: 38000 },
  { id: 'felipe', name: 'Felipe', img: '/assets/img/users/felipe.jpg', password: '456', totalDescontado: 44225 },
  // { id: 'willians', name: 'Willians', img: '/assets/img/users/willians.jpg', password: '1369' },
  // { id: 'nayara', name: 'Nayara', img: '/assets/img/users/nayara.jpg', password: '1369' }
];

function ImageLogin() {
  const [selected, setSelected] = useState(null);
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Meninos - Login';
  }, []);

  const [totalsByUser, setTotalsByUser] = useState({});
  const [blockings, setBlockings] = useState([]);
  const [pointsCompleted, setPointsCompleted] = useState({});
  const [multipliers, setMultipliers] = useState({});

  // build API url like Dashboard does
  const API_ROOT = env.backendUrl && env.backendUrl.endsWith('/api') ? env.backendUrl.replace(/\/$/, '') : `${env.backendUrl.replace(/\/$/, '')}/api`;
  const API_URL = `${API_ROOT}/dashboard`;

  useEffect(() => {
    let mounted = true;
    const fetchTotals = async () => {
      try {
        const res = await fetch(API_URL, { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const json = await res.json();
        const totals = {};
        (Array.isArray(json) ? json : []).forEach((t) => {
          const key = (t.pessoa || '').toLowerCase();
          const minutes = Number(t.tempo) || 0;
          totals[key] = (totals[key] || 0) + minutes;
        });
        if (mounted) setTotalsByUser(totals);
      } catch (err) {
        console.error('Error fetching totals for ImageLogin', err);
      }
    };
      fetchTotals();
      // also fetch blockings list (only list, no form)
      const fetchBlockings = async () => {
        try {
          const res = await fetch(`${API_ROOT}/blockings`, { headers: { Accept: 'application/json' } });
          if (!res.ok) return;
          const json = await res.json();
          if (mounted) setBlockings(Array.isArray(json) ? json : []);
        } catch (err) {
          console.error('Error fetching blockings for ImageLogin', err);
        }
      };
      fetchBlockings();
  return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch points from API
  useEffect(() => {
    let mounted = true;
    const fetchPoints = async () => {
      try {
        const res = await fetch(`${API_ROOT}/agenda/points-for`, { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const json = await res.json();
        if (mounted && json.data) setPointsCompleted(json.data);
      } catch (err) {
        console.error('Error fetching points for ImageLogin', err);
      }
    };
    fetchPoints();
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // Fetch multipliers from API (tries sensible backend endpoints and fallbacks)
  useEffect(() => {
    let mounted = true;
    const fetchMultipliers = async () => {
      try {
        const map = {};

        // 1) Try listing all multipliers
        try {
          const res = await fetch(`${API_ROOT}/user-multipliers`, { headers: { Accept: 'application/json' } });
          if (res.ok) {
            const json = await res.json();
            const list = Array.isArray(json) ? json : (json && Array.isArray(json.data) ? json.data : []);
            list.forEach(item => {
              const name = (item.user_name || item.name || '').trim();
              if (!name) return;
              // keep the most recent (assume list ordered by valid_from desc)
              if (!(name in map)) map[name] = item.multiplier ?? item.mult ?? item.multiplied ?? null;
            });
          }
        } catch (e) {
          // ignore listing error and try active endpoint per-user below
        }

        // 2) For each configured IMAGE_USERS, try active multiplier endpoint (best accuracy)
        await Promise.all(IMAGE_USERS.map(async (u) => {
          try {
            const name = u.name || u.id;
            const today = new Date().toISOString().slice(0,10);
            const params = new URLSearchParams({ user_name: name, date: today });
            const res = await fetch(`${API_ROOT}/user-multipliers/active?${params.toString()}`, { headers: { Accept: 'application/json' } });
            if (!res.ok) return;
            const json = await res.json();
            if (json && typeof json.multiplier !== 'undefined') {
              map[u.id] = json.multiplier;
              map[u.name] = json.multiplier;
            }
          } catch (err) {
            // ignore per-user active fetch errors
          }
        }));

        if (mounted) setMultipliers(map);
      } catch (err) {
        console.error('Error fetching multipliers for ImageLogin', err);
      }
    };
    fetchMultipliers();
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleSelect = (userId) => {
    setSelected(userId === selected ? null : userId);
  }

  const handleSubmit = () => {
    const user = IMAGE_USERS.find(u => u.id === selected);
    if (!user) {
      alert('Selecione um usuário.');
      return;
    }
    if (password === user.password) {
      // login local simples
  localStorage.setItem('responsavel', user.name);
  localStorage.setItem('user', JSON.stringify({ id: user.id, name: user.name }));
  localStorage.setItem('isAuthenticated', 'true');
      navigate('../agenda');
    } else {
      alert('Senha incorreta.');
    }
  }

  return (
    <div className="login-area space__bottom--r120">
      <div className="container">
        <div className="row">
          <div id="login-form" className="col-sm-12 col-md-12 col-xs-12 col-lg-8 mx-auto">
            <form name="imageLogin" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
              <div className="login-form">
                <div className="row">
                  <div className="col-12 mb-4">
                    <div className="grid-users" style={{display: 'flex', gap: '16px', justifyContent: 'center'}}>
                      {IMAGE_USERS.map(u => (
                        <div key={u.id} onClick={() => handleSelect(u.id)} className={`user-card ${selected === u.id ? 'selected' : ''}`} style={{cursor: 'pointer', textAlign: 'center', position: 'relative', overflow: 'visible'}}>
                          <img src={u.img} alt={u.name} style={{width: 140, height: 100, objectFit: 'cover', borderRadius: 8, border: selected === u.id ? '3px solid #4f46e5' : '2px solid #ddd'}} />
                          <div style={{marginTop: 8, fontWeight: 600}}>
                            {u.name}
                          </div>
                          <span className='destaque tailwind text-xs text-gray-500 mt-1 block text-center font-semibold capitalize' 
                            style={{backgroundColor: 'yellow', width: 30, height: 30, color: '#000', position: 'absolute', top: 8, right: 8, zIndex: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%'}}>
                            {(() => {
                              const byId = multipliers[u.id];
                              const byName = multipliers[u.name];
                              const byIdLower = multipliers[(u.id || '').toLowerCase()];
                              const byNameLower = multipliers[(u.name || '').toLowerCase()];
                              const mult = byId ?? byName ?? byIdLower ?? byNameLower;
                              return mult ? `${mult}x` : '';
                            })()}
                          </span>
                          <span className='tailwind text-xs text-gray-500 mt-1 block text-center font-semibold capitalize'>
                            {(() => {
                              // show total for this user in hours (rounded to integers)
                              const completedPoints = Number(pointsCompleted[u.name] || 0);
                              const descontado = completedPoints - Number(u.totalDescontado || 0);
                              const minutosTotais = descontado * 0.058;
                              const minutosTotaisInt = Math.round(minutosTotais);
                              const baseMinutes = Number(totalsByUser[u.id] || 0);
                              const minutes = Math.round(baseMinutes + minutosTotaisInt);
                              const h = Math.floor(minutes / 60);
                              const m = minutes % 60;
                              if (h === 0 && m === 0) return '0h';
                              return m === 0 ? `${h}h` : `${h}h ${m}m`;
                            })()}
                          </span>
                          <span className='tailwind text-xs text-gray-500 mt-1 block text-center font-semibold capitalize'>
                            Pontos: {pointsCompleted[u.name] || 0}
                          </span>
                          {/* <span className='tailwind text-xs text-gray-500 mt-1 block text-center font-semibold capitalize'>
                            Calculados: {u.totalDescontado - pointsCompleted[u.name]}
                          </span>
                          <span className='tailwind text-xs text-gray-500 mt-1 block text-center font-semibold capitalize'>
                            Tempo (minutos): {(pointsCompleted[u.name] - u.totalDescontado ) * 0.058}
                          </span>
                          <span className='tailwind text-xs text-gray-500 mt-1 block text-center font-semibold capitalize'>
                            Tempo (horas): {((pointsCompleted[u.name] - u.totalDescontado ) * 0.058) / 60}
                          </span> */}
                        </div>
                      ))}
                    </div>
                  </div>

                  {selected && (
                  <div className="col-md-12 col-12 space__bottom--20">

                    {/* Display mascarado */}
                    <div style={{display: 'flex', justifyContent: 'center', marginTop:8, marginBottom:12}}>
                      <div style={{maxWidth:360, width:'100%', display:'flex', alignItems:'center', justifyContent:'center', gap:8, padding:8, borderRadius:8, background:'#fff', border:'1px solid #e5e7eb', minHeight:40}}>
                        {Array.from({length: password.length}).map((_,i) => (
                          <div key={i} style={{width:14, height:14, borderRadius:7, background:'#111'}}></div>
                        ))}
                        {password.length === 0 && <div style={{width:14, height:14}} />}
                      </div>
                    </div>

                    {/* Teclado numérico (visível apenas se um usuário estiver selecionado) */}
                    
                      <div className="pin-pad" style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:12, maxWidth:360, margin:'0 auto'}}>
                        {[1,2,3,4,5,6,7,8,9].map(n => (
                          <button key={n} type="button" onClick={() => setPassword(p => p + String(n))} className="default-btn" style={{padding:'18px 0', fontSize:20, borderRadius:8}}>{n}</button>
                        ))}

                        <button type="button" onClick={() => setPassword('')} className="default-btn" style={{padding:'18px 0', fontSize:16, borderRadius:8}}>CLR</button>
                        <button type="button" onClick={() => setPassword(p => p + '0')} className="default-btn" style={{padding:'18px 0', fontSize:20, borderRadius:8}}>0</button>
                        <button type="button" onClick={() => setPassword(p => p.slice(0, -1))} className="default-btn" style={{padding:'18px 0', fontSize:18, borderRadius:8}}>⌫</button>
                      </div>
                  </div>
                  )}

                  {selected && (
                    <div className="col-md-12" style={{display: 'flex', justifyContent: 'center'}}>
                      <div style={{maxWidth: 360, width: '100%'}}>
                        <button type="submit" className="default-btn mt-0" style={{width: '100%'}}>Entrar</button>
                      </div>
                    </div>
                  )}

                  {/* Blockings list (mobile-first) */}
                  <div className="col-12 mt-4">
                    <div className="bg-white rounded p-3 shadow max-w-lg mx-auto">
                      <div className="flex items-center justify-between mb-2">
                        <div className="text-sm font-semibold">Bloqueios até o dia:</div>
                        <div className="text-xs text-gray-400">{blockings.length} encontrados</div>
                      </div>
                      {blockings.length === 0 ? (
                        <div className="text-gray-500 text-sm">Nenhum bloqueio registrado.</div>
                      ) : (
                        <div className="space-y-2">
                          {blockings.slice().sort((a,b)=> (a.periodo||'').localeCompare(b.periodo||'')).reverse().slice(0,6).map(it => (
                            <div key={it.id} className="flex items-start space-x-3 p-2 border rounded">
                                <div className="w-12 h-12 rounded overflow-hidden flex items-center justify-center">
                                  {(() => {
                                    const pessoa = (it.pessoa || '').toLowerCase().trim();
                                    const user = IMAGE_USERS.find(u => (u.id || '').toLowerCase() === pessoa || (u.name || '').toLowerCase() === pessoa);
                                    if (user) {
                                      return (
                                        <img
                                          src={user.img}
                                          alt={user.name}
                                          style={{width:48, height:48, objectFit:'cover'}}
                                        />
                                      );
                                    }
                                    // fallback: name from pessoa
                                    const name = (it.pessoa || '').split(' ').map(s => s[0]).filter(Boolean).slice(0,2).join('').toUpperCase();
                                    return (
                                      <div className="w-12 h-12 bg-indigo-50 rounded flex items-center justify-center text-indigo-600 font-semibold text-sm">
                                        {name || '—'}
                                      </div>
                                    );
                                  })()}
                                </div>
                              <div className="flex-1">
                                <div className="text-sm font-medium">{it.objeto}</div>
                                <div className="text-xs text-gray-500">{it.pessoa} • {it.periodo}</div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImageLogin;
